import { render } from "./Achievements.vue?vue&type=template&id=e4667952&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"

import "./Achievements.vue?vue&type=style&index=0&id=e4667952&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src3857685418/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4667952"]])

export default __exports__